export const articles = [
  {
    id: "1",
    title: "某知名网红直播翻车现场，粉丝当场脱粉百万",
    slug: "wanghong-zhibo-fanche",
    excerpt: "昨晚某千万粉丝级网红在直播中因不当言论引发轩然大波，短短半小时掉粉超过100万，直播间被平台紧急关闭。",
    content: `<p>昨晚8点，拥有超过1500万粉丝的知名网红"小糖果"在例行直播中，因回应粉丝质疑时情绪失控，发表了一系列不当言论。</p><p>据观看直播的网友描述，当时有粉丝在弹幕中质疑其带货产品质量问题，"小糖果"先是不予理会，随后在被连续追问后突然暴怒，直接怒怼粉丝"爱买不买，不买滚蛋"。</p><p>此言论一出，直播间弹幕瞬间炸锅。大量粉丝表示失望并开始取关，据第三方数据平台统计，在短短半小时内，"小糖果"的粉丝数从1523万骤降至1410万，掉粉超过113万。</p><p>更严重的是，直播平台在接到大量用户举报后，于当晚8点35分紧急关闭了该直播间，并对"小糖果"的账号进行了24小时封禁处理。</p><p>事件发酵至今，已有多个品牌方宣布与"小糖果"解除合作关系。某知名美妆品牌在官方微博发布声明称："我们注意到合作伙伴的不当行为，已决定立即终止所有合作关系。"</p><p>业内人士分析认为，这次事件对"小糖果"的商业价值将造成重创。据估算，仅代言解约一项，其损失就将超过2000万元。</p>`,
    category: "yiqu",
    categoryName: "一区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20portrait%20of%20a%20streamer%20in%20dramatic%20lighting%2C%20dark%20green%20and%20black%20color%20palette%2C%20cinematic%20atmosphere%2C%20grainy%20texture%2C%20low%20key%20lighting%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20soft%20shadows%20on%20face%2C%20dark%20minimalist%20background%2C%20professional%20studio%20shot&width=800&height=1067&seq=article-wanghong-01&orientation=portrait",
    date: "2026-07-06",
    views: 1285000,
    comments: 8942,
    author: "吃瓜小编",
    tags: ["网红", "直播翻车", "掉粉", "品牌解约"],
    featured: true,
    trending: true,
  },
  {
    id: "2",
    title: "娱乐圈再曝惊天大瓜！顶流男星疑似隐婚生子",
    slug: "dingliu-nanxing-yinhun",
    excerpt: "据知情人士透露，某顶流男星已在三年前秘密结婚，妻子为圈外人并育有一子，消息一经传出立刻引爆全网。",
    content: `<p>今日凌晨，一位自称圈内资深人士的博主在社交平台发布长文，爆料某顶流男星已在三年前秘密结婚。</p><p>该博主称："这位男星在圈内以单身人设吸粉无数，但事实上他早在2023年就已与一位圈外女性登记结婚，并在2024年初喜得一子。为了维护商业价值，男方团队一直将此事严格保密。"</p><p>虽然爆料者并未直接点名，但根据其描述的"近年爆红"、"多部热播剧男主"、"代言超过20个品牌"等特征，网友迅速将目标锁定在了几位当红男星身上。</p><p>目前，被网友猜测最多的三位男星及其工作室均未对此事作出回应。但有心细的网友发现，其中一位男星的社交账号在爆料发出后的半小时内，悄然删除了多条关于"单身生活"的旧动态。</p><p>这一细节更是引发网友热议，"隐婚"话题迅速登上热搜榜首，阅读量在3小时内突破8亿。</p><p>法律界人士表示，明星隐婚本身并不违法，但如果利用单身人设进行商业代言并获得收益，可能涉及虚假宣传，品牌方有权追究违约责任。</p>`,
    category: "yiqu",
    categoryName: "一区",
    imageUrl: "https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20of%20a%20man%20in%20shadow%2C%20dark%20cinematic%20lighting%2C%20deep%20green%20tones%2C%20film%20noir%20aesthetic%2C%20dramatic%20atmosphere%2C%20low%20contrast%2C%20grainy%20texture%2C%20minimalist%20dark%20background%2C%20editorial%20fine%20art%20photography%2C%20subtle%20moody%20vibe&width=800&height=1067&seq=article-star-02&orientation=portrait",
    date: "2026-07-06",
    views: 2350000,
    comments: 15678,
    author: "娱乐圈探长",
    tags: ["明星", "隐婚", "顶流", "热搜"],
    featured: true,
    trending: true,
  },
  {
    id: "3",
    title: "某女团成员被曝整容前后对比照，变化堪比换头",
    slug: "nvtuan-zhengrong-duibi",
    excerpt: "一组某当红女团成员的旧照在网络上疯传，与现在的容貌差异巨大，引发网友关于整容的热烈讨论。",
    content: `<p>近日，一组据称为某当红女团成员的旧照在各大社交平台疯传，照片中的女孩与现在的精致面容判若两人。</p><p>这组照片据称拍摄于该成员出道前的高中时期，照片中的她脸型偏圆，鼻梁较低，眼睛也远不如现在这般大而有神。而如今舞台上的她，拥有标准的瓜子脸、高挺的鼻梁和一双电力十足的大眼睛，变化之大令人咋舌。</p><p>照片曝光后，网友迅速分成两派。一派认为"这是赤裸裸的换头，整容模板级别"；另一派则为偶像辩护称"女大十八变，化妆和减肥的效果不容忽视"。</p><p>有专业整形医生在接受媒体采访时表示："从专业角度分析，该成员可能进行了双眼皮手术、鼻综合、面部轮廓调整等多个项目，但最终效果确实非常自然，堪称整形界的教科书案例。"</p><p>截至目前，该成员及其所属经纪公司均未就此事发表官方声明。但其粉丝后援会发布公告称："请停止传播恶意对比图，每个女孩都有变美的权利。"</p>`,
    category: "erqu",
    categoryName: "二区",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20portrait%20of%20a%20female%20face%20in%20dramatic%20shadow%20lighting%2C%20dark%20green%20and%20black%20color%20scheme%2C%20mysterious%20aesthetic%2C%20editorial%20beauty%20photography%2C%20low%20key%20studio%20lighting%2C%20dark%20minimalist%20backdrop%2C%20soft%20contrast%2C%20glamour%20vibe&width=800&height=1067&seq=article-girlgroup-03&orientation=portrait",
    date: "2026-07-05",
    views: 1890000,
    comments: 12340,
    author: "颜值鉴定师",
    tags: ["女团", "整容", "对比照", "颜值"],
    featured: true,
    trending: false,
  },
  {
    id: "4",
    title: "网红带货又出事！号称纯天然产品被检出违禁成分",
    slug: "wanghong-daihuo-weijin",
    excerpt: "某百万粉丝美妆博主推荐的面膜被专业机构检测出含有激素成分，多位消费者使用后出现严重过敏反应。",
    content: `<p>网红带货翻车事件又添一例。近日，一位拥有300万粉丝的美妆博主"美美酱"大力推荐的某品牌面膜，被消费者送检后发现含有违禁激素成分。</p><p>据悉，这款面膜主打"纯天然植物萃取"、"零添加"概念，在"美美酱"的直播间售价为199元/盒，短短一个月内销量突破50万盒。</p><p>然而，近日陆续有消费者反映使用后出现面部红肿、瘙痒、脱皮等过敏症状。其中一位消费者王女士将产品送至第三方检测机构，检测结果显示该面膜含有糖皮质激素——氯倍他索丙酸酯，这是一种被国家药监局明令禁止添加在化妆品中的成分。</p><p>"我用了两次脸就肿得像个猪头，去医院诊断为激素依赖性皮炎，治疗了一个月还没好。"王女士愤怒地表示。</p><p>事件曝光后，"美美酱"发布道歉视频称自己也是受害者，被品牌方欺骗。但网友并不买账，有业内人士指出，该博主在推荐前从未对产品进行过任何质量检测。</p><p>目前，市场监管部门已介入调查，涉事面膜已在各大电商平台下架。</p>`,
    category: "erqu",
    categoryName: "二区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20still%20life%20of%20skincare%20products%20in%20dramatic%20shadow%2C%20green%20tinted%20lighting%2C%20moody%20mysterious%20composition%2C%20dark%20minimalist%20background%2C%20cinematic%20product%20photography%2C%20low%20key%20lighting%2C%20elegant%20danger%20aesthetic%2C%20editorial%20style&width=800&height=1067&seq=article-skincare-04&orientation=portrait",
    date: "2026-07-05",
    views: 1560000,
    comments: 9876,
    author: "消费维权记者",
    tags: ["网红带货", "违禁成分", "面膜", "消费者权益"],
    featured: false,
    trending: true,
  },
  {
    id: "5",
    title: "知名导演深夜发文暗示某影后私生活混乱，随后秒删",
    slug: "daoyan-fawen-yingshi",
    excerpt: "一位曾获得金马奖的知名导演深夜发布一条疑似暗指某影后的动态，内容劲爆，但发布不到五分钟即被删除。",
    content: `<p>昨晚深夜11时许，曾执导过多部获奖影片的知名导演陈某某在其个人社交账号上发布了一条耐人寻味的动态。</p><p>动态内容为："有些人台上光鲜亮丽，台下做的事情让人不齿。某影后，你以为没人知道你在剧组里都做了什么吗？"虽然全文没有指名道姓，但"影后"二字的指向已经非常明确。</p><p>这条动态发布后迅速引起网友关注，但令人意外的是，不到五分钟该动态就被删除。尽管如此，早有手快的网友截图保存，截图在各大粉丝群和论坛中迅速传播。</p><p>网友们纷纷开始猜测这位导演所指的"影后"到底是谁。有人根据该导演最近合作过的女演员进行排查，锁定了三位可能的候选人。</p><p>截至目前，涉事导演和被网友猜测的三位女演员均未作出回应。但据圈内人士透露，该导演最近正在筹备一部新片，不排除此举是为了炒作新片的可能性。</p>`,
    category: "yiqu",
    categoryName: "一区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20phone%20screen%20glowing%20in%20darkness%2C%20green%20noir%20lighting%2C%20mysterious%20atmosphere%2C%20low%20key%20photography%2C%20film%20noir%20aesthetic%2C%20dark%20minimalist%20background%2C%20text%20on%20screen%2C%20dramatic%20moody%20vibe&width=800&height=1067&seq=article-director-05&orientation=portrait",
    date: "2026-07-04",
    views: 980000,
    comments: 5678,
    author: "深夜吃瓜人",
    tags: ["导演", "影后", "深夜发文", "秒删"],
    featured: false,
    trending: true,
  },
  {
    id: "6",
    title: "选秀节目黑幕曝光！某选手花500万买出道位",
    slug: "xuanxiu-heimu-chudao",
    excerpt: "一位自称前选秀节目工作人员的网友爆料，某选手的家人花费500万元购买了节目出道位，并提供了部分转账记录截图。",
    content: `<p>随着又一档选秀节目落下帷幕，关于选秀黑幕的讨论再次升温。今天上午，一位自称是某选秀节目前工作人员的网友发布长文，揭露了节目组与选手之间的金钱交易。</p><p>该爆料者称，在节目中最终获得第三名出道的选手，其家人通过多层关系向节目组的核心制作人员支付了500万元"保出道费"。爆料贴中还附上了几张据称为转账记录的截图。</p><p>"这个选手的实力其实很一般，在最初的内部评估中连前20都进不了。但他家人舍得花钱，一路买到了第三名。"爆料者写道。</p><p>此爆料一出，舆论哗然。大量网友涌入该选手的社交账号评论区要求其回应。有愤怒的粉丝表示："我们辛辛苦苦投票打榜，结果人家直接用钱买，太恶心了。"</p><p>节目制作方火速发布声明称"所有比赛结果公平公正，绝不存在任何金钱交易"，并表示将追究造谣者的法律责任。</p><p>但令人玩味的是，该声明发布后不久，又有两位自称业内人士的账号转发了爆料贴，并评论"终于有人说了"。</p>`,
    category: "erqu",
    categoryName: "二区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20stage%20with%20dramatic%20spotlight%2C%20green%20tinted%20darkness%2C%20empty%20stage%20atmosphere%2C%20mysterious%20performance%20venue%2C%20low%20key%20lighting%2C%20theatrical%20cinematic%20photography%2C%20dark%20minimalist%20composition%2C%20editorial%20fine%20art&width=800&height=1067&seq=article-show-06&orientation=portrait",
    date: "2026-07-04",
    views: 2100000,
    comments: 14520,
    author: "选秀观察员",
    tags: ["选秀", "黑幕", "出道位", "金钱交易"],
    featured: true,
    trending: true,
  },
  {
    id: "7",
    title: "某综艺节目录制现场爆发激烈冲突，嘉宾当场罢录",
    slug: "zongyi-chongtu-balu",
    excerpt: "热门综艺录制现场突发状况，两位明星嘉宾因意见不合发生口角升级为肢体冲突，节目组紧急叫停录制。",
    content: `<p>据现场观众爆料，昨天下午某热门综艺节目的录制现场发生了一起罕见的明星冲突事件。</p><p>据了解，冲突起因是两位明星嘉宾在游戏环节中因胜负判定产生了分歧。其中一位认为对方作弊，而另一位则坚称自己遵守了规则。口角很快升级为激烈的争吵，据称其中一位嘉宾甚至推了对方一把。</p><p>现场观众描述说："当时气氛特别紧张，工作人员都看傻了。被推的那位直接说'我不录了'，然后就带着助理离开了现场。"</p><p>节目组紧急叫停了录制，导演和制片人出面协调了将近两个小时，但最终该期节目还是未能完成录制。</p><p>事件发生后，两位当事人的粉丝在社交平台上展开了激烈的"互撕"，双方互相指责对方偶像"没素质"、"耍大牌"。相关话题在半小时内冲上热搜前三名。</p><p>节目组随后发布声明称"正在积极协调各方，确保节目后续录制顺利进行"，但并未透露具体冲突细节。</p>`,
    category: "yiqu",
    categoryName: "一区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20tense%20atmosphere%20with%20two%20figures%20in%20confrontation%2C%20green%20moody%20lighting%2C%20dramatic%20shadows%2C%20cinematic%20tension%2C%20low%20key%20photography%2C%20dark%20minimalist%20backdrop%2C%20film%20noir%20style%2C%20intense%20editorial%20shot&width=800&height=1067&seq=article-conflict-07&orientation=portrait",
    date: "2026-07-03",
    views: 1750000,
    comments: 11023,
    author: "综艺前线",
    tags: ["综艺", "冲突", "罢录", "明星"],
    featured: false,
    trending: true,
  },
  {
    id: "8",
    title: "网红情侣官宣分手！三年恋情终结，双方已互相取关",
    slug: "wanghong-qinglv-fenshou",
    excerpt: "网红圈又一神雕侠侣宣告分手，男方发文感谢三年陪伴，女方则删除了所有合照，双方已互相取关。",
    content: `<p>今天下午，坐拥合计超过2000万粉丝的网红情侣"小宇"和"朵朵"同时发布声明，宣布结束三年的恋情。</p><p>男方"小宇"在文中写道："感谢这三年来的陪伴与成长，我们选择了不同的方向，但依然祝福对方。希望大家给我们一些空间。"</p><p>而女方"朵朵"的声明则更为简短："分手了，各自安好。"同时，细心的网友发现她已经删除了社交账号上所有与"小宇"的合照。</p><p>双方目前已互相取关，曾经甜蜜的情侣账号"宇朵日常"也已停止更新。据悉，两人共同经营的品牌和商业合作将由第三方进行资产分割。</p><p>粉丝们对此反应强烈，两人的评论区充斥着"不相信爱情了"、"再也不嗑CP了"等留言。"宇朵分手"话题迅速登上热搜，阅读量在2小时内突破5亿。</p><p>有知情人士透露，两人分手的真正原因是事业发展方向产生分歧，"小宇"希望转型做幕后投资人，而"朵朵"则想继续深耕直播带货领域。</p>`,
    category: "erqu",
    categoryName: "二区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20scene%20of%20two%20figures%20walking%20apart%2C%20green%20moody%20aesthetic%2C%20emotional%20separation%20concept%2C%20low%20key%20cinematic%20photography%2C%20dark%20minimalist%20background%2C%20grainy%20texture%2C%20melancholic%20editorial%20style&width=800&height=1067&seq=article-couple-08&orientation=portrait",
    date: "2026-07-03",
    views: 890000,
    comments: 7823,
    author: "网红观察家",
    tags: ["网红情侣", "分手", "取关", "CP"],
    featured: false,
    trending: false,
  },
  {
    id: "9",
    title: "深度揭秘：某MCN机构如何批量制造网红和控制舆论",
    slug: "mcn-jigou-jiexi",
    excerpt: "一篇深度调查报道揭示了头部MCN机构的运作内幕，包括批量孵化账号、数据造假、控制评论区等操作手法。",
    content: `<p>近日，一篇关于MCN机构运作内幕的深度调查报道在网络上引发热议。</p><p>该报道以某头部MCN机构为案例，详细揭露了其如何通过系统化的流程批量制造网红。根据报道，该机构拥有超过500个活跃账号，覆盖美妆、美食、搞笑、情感等多个领域。</p><p>报道指出，这些账号的粉丝增长并非自然积累，而是通过"互关矩阵"、"刷量服务"等手段人为制造的。"一个新号从零到百万粉，最快只需要三个月。"一位前员工在接受采访时透露。</p><p>更令人震惊的是，该机构还拥有专业的"舆论控制"团队，负责监控旗下网红的相关评论，通过批量举报、刷好评、水军引导舆论等方式维护网红形象。</p><p>"如果有人在评论区说了不利于我们网红的话，我们会组织几十上百个小号去围攻他，直到他删评为止。"该前员工说。</p><p>报道发布后，多家MCN机构紧急发布声明，否认存在上述行为。但业内普遍认为，这仅仅是行业乱象的冰山一角。</p>`,
    category: "yiqu",
    categoryName: "一区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20with%20glowing%20screens%2C%20green%20noir%20lighting%2C%20mysterious%20atmosphere%2C%20low%20key%20cinematography%2C%20dark%20minimalist%20background%2C%20corporate%20espionage%20vibe%2C%20dramatic%20editorial%20photography&width=800&height=1067&seq=article-mcn-09&orientation=portrait",
    date: "2026-07-02",
    views: 670000,
    comments: 4567,
    author: "深度调查部",
    tags: ["MCN", "网红孵化", "数据造假", "舆论控制"],
    featured: false,
    trending: false,
  },
  {
    id: "10",
    title: "某歌手演唱会假唱被现场揭穿，观众高喊退票",
    slug: "geshou-jiachang-tuipiao",
    excerpt: "一位知名歌手在演唱会上被观众发现假唱，现场一度混乱，数百名观众齐声高喊退票，场面尴尬。",
    content: `<p>昨晚，某知名流行歌手在其巡回演唱会上发生了戏剧性的一幕——被现场观众当场揭穿假唱。</p><p>据现场粉丝描述，在演唱一首高难度歌曲时，该歌手在间奏时忘记将麦克风放回嘴边，但歌声仍在继续播放。发现这一情况的观众起初是惊讶，随后有人大喊"假唱"，现场瞬间沸腾。</p><p>"麦克风都放下了，声音还在那儿响，这不是假唱是什么？"一位现场观众愤怒地说。另一位购买了VIP票（票价1880元）的观众则表示："花这么多钱来看演唱会，结果给我放录音，这不是诈骗吗？"</p><p>随后，数百名观众开始齐声高喊"退票"，场面一度混乱。演出被迫中断约20分钟，最终在安保人员的维护下才勉强完成了后续曲目。</p><p>事件发生后，"假唱退票"话题迅速登上热搜。演出主办方在凌晨发布致歉声明，称"由于技术原因"导致部分曲目使用了预录音轨，并承诺为不满意观众办理退票。</p><p>但网友们并不买账，纷纷吐槽："技术原因就是假唱的万能借口吗？"</p>`,
    category: "erqu",
    categoryName: "二区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20concert%20stage%20with%20dramatic%20spotlight%20and%20shadow%2C%20green%20noir%20atmosphere%2C%20empty%20microphone%20stand%2C%20low%20key%20photography%2C%20cinematic%20lighting%2C%20dark%20minimalist%20backdrop%2C%20moody%20editorial%20style&width=800&height=1067&seq=article-concert-10&orientation=portrait",
    date: "2026-07-02",
    views: 1340000,
    comments: 8901,
    author: "音乐现场报道",
    tags: ["歌手", "假唱", "演唱会", "退票"],
    featured: true,
    trending: true,
  },
  {
    id: "11",
    title: "某短视频平台大V涉嫌诈骗粉丝，涉案金额超千万",
    slug: "duanshipin-dav-zhapian",
    excerpt: "一位拥有800万粉丝的短视频大V被多名粉丝联名举报，涉嫌以投资名义诈骗粉丝钱财，警方已立案调查。",
    content: `<p>今天上午，多名网友在社交平台联合发声，举报一位拥有800万粉丝的短视频平台大V涉嫌诈骗。</p><p>据举报人描述，该大V在过去一年中以"内部投资机会"、"稳赚不赔的项目"为名，向其粉丝募集资金。受害者少则投入数万元，多则超过百万元。据不完全统计，涉案总金额已超过1000万元。</p><p>"他每天都在视频里展示豪车豪宅，让人觉得很成功很靠谱。然后私信跟你说有一个很好的投资机会，带你一起发财。"一位损失了35万元的受害者说。</p><p>然而，所谓的投资项目从未有过任何回报。当投资者要求退款时，该大V以各种理由推脱，最后甚至直接失联。受害者们才发现自己被骗了。</p><p>目前，已有超过50名受害者联名向公安机关报案，警方已正式立案调查。该大V的所有社交账号均已设为私密，疑似已潜逃。</p><p>此事件再次引发了公众对网红经济乱象的关注。有专家呼吁，应加强对网红商业行为的监管，保护粉丝的合法权益。</p>`,
    category: "yiqu",
    categoryName: "一区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20handcuffs%20and%20money%20in%20shadow%2C%20green%20noir%20lighting%2C%20crime%20investigation%20aesthetic%2C%20low%20key%20photography%2C%20dramatic%20atmosphere%2C%20dark%20minimalist%20background%2C%20cinematic%20editorial%20style&width=800&height=1067&seq=article-fraud-11&orientation=portrait",
    date: "2026-07-01",
    views: 2980000,
    comments: 18923,
    author: "法治观察员",
    tags: ["短视频", "大V", "诈骗", "立案"],
    featured: true,
    trending: true,
  },
  {
    id: "12",
    title: "某知名主持人被曝私下辱骂工作人员，录音曝光",
    slug: "zhuchiren-ruma-gongzuorenyuan",
    excerpt: "一段疑似某知名主持人在后台辱骂工作人员的录音在网络上流传，言语之恶劣令人震惊。",
    content: `<p>今天，一段长约3分钟的录音在网络上疯传，据称是某卫视知名主持人在节目录制后台辱骂工作人员的对话。</p><p>录音中可以清晰听到一名男性用极其恶劣的语言训斥工作人员，内容包括"你是猪脑子吗"、"这么简单的事都做不好，趁早滚蛋"等侮辱性言辞。录音最后还能听到疑似摔东西的声音和工作人员的哭泣声。</p><p>虽然录音中的声音经过了一些处理，但网友根据音色和说话方式，迅速锁定了三位知名男主持人作为怀疑对象。</p><p>事件发酵后，该主持人的社交媒体账号评论区被愤怒的网友"攻陷"。"台上一套台下一套"、"德不配位"等评论刷屏。</p><p>该主持人所属的电视台表示"正在核实相关情况"，但截至目前尚未发布正式声明。</p><p>业内人士表示，主持人私下态度恶劣的问题并非个案，只是很少有如此直接的证据流出。"很多艺人在镜头前和镜头后完全是两个人。"</p>`,
    category: "erqu",
    categoryName: "二区",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20backstage%20atmosphere%20with%20microphone%20in%20shadow%2C%20green%20moody%20lighting%2C%20tense%20dramatic%20vibe%2C%20low%20key%20cinematography%2C%20dark%20minimalist%20setting%2C%20film%20noir%20editorial%20photography&width=800&height=1067&seq=article-host-12&orientation=portrait",
    date: "2026-07-01",
    views: 1670000,
    comments: 10234,
    author: "后台爆料人",
    tags: ["主持人", "辱骂", "录音", "人设崩塌"],
    featured: false,
    trending: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured);
export const trendingArticles = articles.filter((a) => a.trending);
export const latestArticles = [...articles].sort((a, b) => b.date.localeCompare(a.date));